import moment from 'moment'
import {injectableClass} from '../utils/Utils'

export let CMD = {
  BUY: 0,
  SELL: 1,
  BUY_LIMIT: 2,
  SELL_LIMIT: 3,
  BUY_STOP: 4,
  SELL_STOP: 5,
}

@injectableClass("webtrader", "Quotes", "Account", "$http")
export class BaseTrade {
  constructor(data) {
    this.update(data)
  }

  update(data) {
    _.extend(this, data)

    for (let dtField of ['open_time', 'close_time', 'expiration', 'modify_time']) {
      if (!this[dtField] || (this[dtField].startsWith && this[dtField].startsWith('1970')))
        this[dtField] = null
      // Since mt4 sends data in it's tz, which is +3, revert to utc
      else if (this[dtField] % 1 === 0)
        this[dtField] = moment.unix(this[dtField]).utc()
    }

    if (this.isOpen)
      this.recalculateProfit()
  }

  get isOpen() {
    return [0, 1, 6, 7].includes(this.cmd) && !this.close_time
  }

  get isPending() {
    return [2, 3, 4, 5].includes(this.cmd) && !this.close_time
  }

  get isClosed() {
    return this.cmd < 8 && !!this.close_time
  }

  get isSell() {
    return [CMD.SELL, CMD.SELL_LIMIT, CMD.SELL_STOP].includes(this.cmd)
  }

  get isBuy() {
    return [CMD.BUY, CMD.BUY_LIMIT, CMD.BUY_STOP].includes(this.cmd)
  }

  get marketPrice() {
    return this.isSell? this.quote.ask : this.quote.bid
  }

  get quote() {
    return this.constructor.Quotes.mapping[this.symbol]
  }

  get cmdDisplay() {
    return this.constructor.Account.info.cmd_types[this.cmd]
  }

  loadData() {
    return this.constructor.$http.get(`${this.constructor.Account.BASE_URL}/trade/${this.ticket}/`)
  }

  delete() {
    this.isLoading = true
    let q = this.constructor.$http.delete(`${this.constructor.Account.BASE_URL}/trade/${this.ticket}/`)
    q.finally(() => this.isLoading = false)
    return q
  }

  recalculateProfit() {

  }

  startEdit(field) {
    this[field+'New'] = this[field]
    this[field+'Editing'] = true
  }
  saveEdit(field) {
    this[field+'Editing'] = false
    this.isLoading = true
    let data = {}
    data[field] = this[field+'New']
    let q = this.constructor.$http.put(`${this.constructor.Account.BASE_URL}/trade/${this.ticket}/`, data)
    q.then(() => {
      this[field] = this[field+'New']
    })
    q.finally(() => {
      this.isLoading = false
      this.cancelEdit(field)
    })
    return q
  }
  cancelEdit(field) {
    delete this[field+'Editing']
    delete this[field+'New']
  }
}
